import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const formularios = {
	state: {
		
	},
	getters: {

	},
	actions: {
		sendContacto : ({commit}, data) => {
			return new Promise((resolve, reject) => {
				axios.post('/api/contacto',data).then( result => {
					(result.data == 1) ? resolve(true) : reject(false);
				}).catch(error => {
					reject(false);
				});  
			});	
		},
		sendTrabajaConNosotros : ({commit}, data)  => {
			
			return new Promise((resolve, reject) => {
				

				$.ajax({
					url: `https://dmb-ajusa.dev.doubledot.es/api/contacto`,
					type: 'POST',
					data: data,
					cache: false,
					contentType: false,
					processData: false,
				})
				.done(function(r) {
					if(r == 1){
						resolve(true);
					}
				})
				.fail(function(error) {
					reject(false)
				});

			});		

		}
	},
	mutations: {
		
	}
}

export default formularios;



// WEBPACK FOOTER //
// ./src/store/formularios.js